<!--  -->
<template>
  <div style="">
    <div class="band_box">
      <div>
        <div class="serch_box">
          <el-input v-model="obr.keywords" clearable style="width: 240px" placeholder="请输入转发源企业员工" />
          <el-button type="primary" class="search_icon" icon="el-icon-search" @click="secahclkick" />
        </div>

        <div class="choose_allblock">
          <div v-for="(item, index) in enterpriseemploye" :key="index" class="selegarge">
            <div class="select_box" :class="[item.tips ? 'choose_blockr' : '']" @click="itenclick(item, index)" />
            <span class="spanbox">{{ item.name + '(' + item.corp_name + ')' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <pagination-right style="padding: 0px; margin-top: 20px; justify-content: left" :pager-count="5" :total="total" :current-page="obr.page" :page-sizes="[10]" @size-change="fetchPageSize" @current-change="fetchCurrentPage" />
    </div>

    <div class="que_box">
      <el-button type="primary" @click="quebtn">确定</el-button>
    </div>
  </div>
</template>

<script>
import { enterpriseEmployee } from '@/api/enterprisewechatControl'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      enterpriseemploye: [],
      box_id: null,
      obr: {
        keywords: null,
        page: 1, // 当前页码
        pageSize: 10 // 显示数据条数
      },
      backitem: null,
      total: null
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    send(box_id) {
      this.box_id = box_id
      this.enteree()
    },

    // 转发源企业员工筛选
    async enteree() {
      const data = await enterpriseEmployee(this.obr)
      this.enterpriseemploye = data.data.list
      this.enterpriseemploye.forEach(item => {
        item.tips = false
      })
      this.total = data.data.total
    },

    secahclkick() {
      this.obr.page = 1
      this.obr.pageSize = 10
      this.enteree()
    },

    // 点击确定
    async quebtn() {
      const isValid = this.enterpriseemploye.every(i => i.tips === false) //判断是否已选
      if (isValid) {
        this.$message({
          message: '请选择转发源企业员工',
          type: 'error'
        })
      } else {
        this.$emit('labelchoose', this.backitem, this.box_id)
      }
    },

    itenclick(item, index) {
      this.backitem = null
      this.enterpriseemploye.forEach(i => (i.tips = false))
      this.$set(item, 'tips', true)
      this.backitem = item
      this.$forceUpdate()
    },

    fetchPageSize(e) {
      this.obr.pageSize = e
      this.enteree()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.enteree()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.selegarge {
  display: flex;
  margin-bottom: 8px;
}
.spanbox {
  font-size: 15px;
}
.choose_blockr {
  background: #409eff;
}
.que_box {
  margin-top: 20px;
}
.serch_box {
  display: flex;
  margin-bottom: 20px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 15px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.choose_allblock {
  min-height: 350px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  /* min-width: 600px; */
}
</style>
